import LLLogo from './Images/LLLogo.png';
// import React, { useState } from 'react';
// import axios from 'axios';
// import './Magic.css'; // Ensure to update the CSS file to reflect the new styles

// // Top Navigation Bar
// function PageTopper() {
//   return (
//     <header className="page-topper">
//       <div className="nav-container">
//         <img src={LLLogo} className="logo" alt="Laugh Letter Games Logo" />
//         <nav className="navigation">
//           <a href="#inventory-update">Inventory Update</a>
//           <a href="#price-update">Price Update</a>
//         </nav>
//       </div>
//       <div className="hero-section">
//         <h1>Welcome to Laugh Letter Games!</h1>
//         <p>Your trusted partner in gaming inventory management.</p>
//       </div>
//     </header>
//   );
// }

// // Main Component
// function RunPythonScript() {
//   const [output, setOutput] = useState(null);
//   const [error, setError] = useState(null);

//   const runScript = async () => {
//     try {
//       const response = await axios.get('http://localhost:5000/run-mtg-inv-update'); // Adjust if using a different port or API
//       setOutput(response.data.output);
//       setError(null);
//     } catch (err) {
//       setError("Failed to run script: " + err.message);
//       setOutput(null);
//     }
//   };

//   const runPrice = async () => {
//     try {
//       const response = await axios.get('http://localhost:5000/run-mtg-prc-update'); // Adjust if using a different port or API
//       setOutput(response.data.output);
//       setError(null);
//     } catch (err) {
//       setError("Failed to run script: " + err.message);
//       setOutput(null);
//     }
//   };

//   return (
//     <div>
//       {/* Render the PageTopper component */}
//       <PageTopper />
//       <main className="main-content">
//         <div className="action-container">
//           <button className="primary-button" onClick={runScript}>
//             Inventory Update
//           </button>
//           <button className="primary-button" onClick={runPrice}>
//             Price Update
//           </button>
//         </div>
//         <div className="output-container">
//           {output && <pre className="output">{output}</pre>}
//           {error && <p className="error">{error}</p>}
//         </div>
//       </main>
//       <footer className="footer">
//         <p>&copy; 2024 Laugh Letter Games. All rights reserved.</p>
//       </footer>
//     </div>
//   );
// }

// export default RunPythonScript;

import React, { useState } from 'react';
import axios from 'axios';
import './Magic.css';

function RunPythonScript() {
  const [filePath1, setFilePath1] = useState(null);
  const [filePath2, setFilePath2] = useState(null);
  const [output, setOutput] = useState(null);
  const [error, setError] = useState(null);
  const [outputFileUrl, setOutputFileUrl] = useState(null);

  const handleFile1Select = (event) => {
    setFilePath1(event.target.files[0]); // Store the selected file for file_path_1
  };

  const handleFile2Select = (event) => {
    setFilePath2(event.target.files[0]); // Store the selected file for file_path_2
  };

  const uploadFilesAndRunScript = async () => {
    if (!filePath1 || !filePath2) {
      setError("Please select both files before running the script.");
      return;
    }

    const formData = new FormData();
    formData.append('file_path_1', filePath1); // Attach the first file
    formData.append('file_path_2', filePath2); // Attach the second file

    try {
      const response = await axios.post('http://localhost:5000/upload-and-run', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      setOutput(response.data.output);
      setError(null);
      setOutputFileUrl(`http://localhost:5000/download/${response.data.outputFileName}`);
    } catch (err) {
      setError("Failed to run script: " + err.message);
      setOutput(null);
    }
  };

  const runPrice = async () => {
    try {
      const response = await axios.get('http://localhost:5000/run-mtg-prc-update');
      setOutput(response.data.output);
      setError(null);
    } catch (err) {
      setError("Failed to run script: " + err.message);
      setOutput(null);
    }
  };

  return (
    <div>
      <header className="page-topper">
        <h1>Laugh Letter Games</h1>
      </header>
      <main className="main-content">
        <div className="file-upload-section">
          <div className="file-input-group">
            <label htmlFor="file_path_1">Select File for File Path 1:</label>
            <input type="file" id="file_path_1" onChange={handleFile1Select} />
          </div>
          <div className="file-input-group">
            <label htmlFor="file_path_2">Select File for File Path 2:</label>
            <input type="file" id="file_path_2" onChange={handleFile2Select} />
          </div>
          <button className="primary-button" onClick={uploadFilesAndRunScript}>
            Inventory Update
          </button>
        </div>
        <div className="action-container">
          <button className="primary-button" onClick={runPrice}>
            Price Update
          </button>
        </div>
        <div className="output-container">
          {output && <pre className="output">{output}</pre>}
          {error && <p className="error">{error}</p>}
          {outputFileUrl && (
            <a href={outputFileUrl} download className="download-link">
              Download Updated Inventory
            </a>
          )}
        </div>
      </main>
    </div>
  );
}

export default RunPythonScript;

